import React, { useEffect, useRef, useState } from 'react';

/**
 * IdefixUspoloCerceve: idefix feed'i için U.S. Polo ürünlerine özel 6 çerçeve seçeneği
 * (1 ortak logo + idefix'in U.S. Polo banner'ından uzatılmış 5 varyant).
 * Route: /r/idefix-uspolo-cerceve (ProtectedRoute allowBrandIds idefix, sidebar'lı).
 *
 * İçerik statik; kareler B2 kovası glowy-studio-idefix/ornek/uspolo/ altında, studio.glowytics.com üzerinden gelir.
 * Yeniden üretmek için: node src/pages/idefix-uspolo-cerceve/build.js
 * iframe srcDoc: sayfanın global seçicileri dashboard stilini bozmasın.
 */
export default function IdefixUspoloCerceve() {
  const [html, setHtml] = useState(null);
  const [height, setHeight] = useState(720);
  const boxRef = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./idefixUspoloCerceveHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // iframe'i içerik alanının kalan yüksekliğine oturt. Rapor kendi içinde kayar,
  // sayfa gövdesi kaymaz — iki kaydırma çubuğu üst üste binmesin.
  useEffect(() => {
    const fit = () => {
      const top = boxRef.current?.getBoundingClientRect().top ?? 0;
      setHeight(Math.max(480, window.innerHeight - top - 16));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [html]);

  return (
    <div ref={boxRef} className="px-2 pb-2">
      {html ? (
        <iframe
          title="idefix × U.S. Polo çerçeveleri"
          srcDoc={html}
          style={{
            width: '100%',
            height,
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            display: 'block',
            background: '#F6F8FF',
          }}
        />
      ) : (
        <div
          style={{ height, borderRadius: 12, background: '#F6F8FF' }}
          aria-busy="true"
        />
      )}
    </div>
  );
}
